'use client';

import {
  noParagraphs,
  paragraphs,
} from '@/components/sections/PortableTextComponents';
import { getForm } from '@/lib/hubspot/services/formService';

import { useState, useEffect } from 'react';
import FormFields from './FormFields';
import FormSubtext from './FormSubtext';
import FormWrapper from './FormWrapper';
import { PortableText } from '@portabletext/react';
import { PortableTextBlock } from 'sanity';
import { AiFillCheckCircle } from 'react-icons/ai';

export default function FormClient(props: {
  form: {
    heading?: PortableTextBlock;
    textContent?: PortableTextBlock;
    subText?: PortableTextBlock;
    formId?: string;
    formType?: string;
    displayOptions?: {
      displayType: 'default' | 'inline' | 'campaign';
      displayMode: 'dark' | 'light';
    };
  };
  formClassName?: string;
  subTextClassName?: string;
}) {
  const { form: formData } = props;
  const [form, setForm] = useState<any>(null);
  const displayOptions = formData?.displayOptions;
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const getFormContent = async () => {
      if (formData?.formId) {
        const fetchedForm = await getForm(formData.formId);
        setForm(fetchedForm);
      }
    };
    getFormContent();
  }, [formData]);

  if (!form) {
    return (
      <div
        className={`mx-auto w-full max-w-xl rounded-3xl bg-white p-8 px-6 py-7 shadow-lg sm:p-8 md:p-10 ${props.formClassName || ''}`}
      >
        <div className='mb-4 h-6 animate-pulse rounded bg-gray-300'></div>
        <div className='mb-8 h-4 animate-pulse rounded bg-gray-300'></div>

        <div className='space-y-4'>
          <div className='h-10 animate-pulse rounded bg-gray-300'></div>
          <div className='h-10 animate-pulse rounded bg-gray-300'></div>
          <div className='h-10 animate-pulse rounded bg-gray-300'></div>
          <div className='h-32 animate-pulse rounded bg-gray-300'></div>
        </div>
      </div>
    );
  } else {
    return (
      <div
        className={`${props.formClassName || ''} ${displayOptions?.displayType === 'campaign' ? 'relative z-200 !mb-0 max-w-[450px] md:absolute md:top-16' : ''}`}
      >
        {displayOptions?.displayType === 'campaign' && isSubmitted ? (
          <div className='mx-auto mt-2 flex max-w-xl flex-col items-center justify-center rounded-3xl border border-gray-200 bg-white px-6 py-7 text-center sm:p-8 md:p-10'>
            <AiFillCheckCircle size={70} color='green' />
            <h1 className='heading-md mt-2 font-display font-medium tracking-tighter'>
              Thank you!
            </h1>
            <p>Your registration has been submitted successfully.</p>
          </div>
        ) : (
          <FormWrapper form={form} formType={formData?.formType}>
            <div
              className={`mx-auto mt-2 max-w-xl border border-gray-200 bg-white px-6 py-7 sm:p-8 md:p-10 ${
                displayOptions?.displayMode === 'dark'
                  ? 'relative inline-flex flex-col bg-[radial-gradient(121.58%_121.58%_at_50%_125.11%,_#D3B203_0%,_#141414_44.39%)]'
                  : ''
              } ${
                displayOptions?.displayType === 'inline'
                  ? 'rounded-[10px] px-6 !pt-16 md:p-6 xl:pb-10 xl:pt-16'
                  : 'rounded-3xl px-6 md:p-10'
              } `}
            >
              <div
                className={`${displayOptions?.displayType === 'campaign' ? 'mb-6' : 'mb-10'} space-y-5`}
              >
                {formData?.heading && (
                  <h2
                    className={`heading-sm font-display font-bold text-charcoal ${displayOptions?.displayType === 'campaign' ? 'text-center' : ''}`}
                  >
                    <PortableText
                      value={formData.heading}
                      components={noParagraphs}
                    />
                  </h2>
                )}
                {formData?.textContent && (
                  <div className='text-charcoal'>
                    <PortableText
                      value={formData.textContent}
                      components={paragraphs}
                    />
                  </div>
                )}
              </div>
              <FormFields
                form={form}
                displayOptions={displayOptions}
                onSubmitStatusChange={(submitted) => setIsSubmitted(submitted)}
              />
              {formData?.subText &&
                displayOptions?.displayType === 'campaign' && (
                  <div
                    className={`mx-auto mt-8 max-w-md px-5 text-xs ${props.subTextClassName || ''}`}
                  >
                    <FormSubtext subText={formData.subText} />
                  </div>
                )}
            </div>
            {formData?.subText &&
              displayOptions?.displayType !== 'campaign' && (
                <div
                  className={`mx-auto mt-8 max-w-md px-5 ${props.subTextClassName || ''}`}
                >
                  <FormSubtext subText={formData.subText} />
                </div>
              )}
          </FormWrapper>
        )}
      </div>
    );
  }
}
